import { useEffect, useState } from 'react'
import { ShieldAlert } from 'lucide-react'
import { listSupportNotifications, type SupportNotification } from '@/services/supportNotifications/supportNotifications.http'
import { isRealMode } from '@/config/runtime'

export default function TenantSupportNotice() {
  const [notice, setNotice] = useState<SupportNotification | null>(null)
  useEffect(() => {
    if (!isRealMode()) return
    listSupportNotifications().then((items) => setNotice(items[0] ?? null)).catch(() => undefined)
  }, [])
  if (!notice) return null
  const active = notice.event_type === 'support_access_activated'
  return <div role="status" className={`mb-4 flex gap-3 rounded-lg border p-3 text-sm ${active ? 'border-amber-400 bg-amber-50 text-amber-950' : 'border-slate-300 bg-slate-50 text-slate-800'}`}>
    <ShieldAlert className="h-5 w-5 shrink-0" /><div><strong>{active ? 'CML support access activated' : 'CML support access ended'}</strong><div>Case {notice.payload.ticket}{active && notice.payload.expires_at ? ` · expires ${new Date(notice.payload.expires_at).toLocaleString()}` : ''}</div></div>
  </div>
}
